export default __webpack_public_path__ + "static/media/icon-insights-performance-calls-answered.6b4ba7b8.svg";